<div class="card">
  <app-reminder-message
    *ngIf="auth.complianceChecks?.expiredAddress || auth.complianceChecks?.expiredPhone"
    message="Algunos de tus datos personales expiraron"
    [type]="'error'"
  >
  </app-reminder-message>

  <div class="data main-data">
    <div class="col">
      <div *ngIf="!auth.loggedUser.flags.clubMember" class="main-info">
        <img
          _ngcontent-kxa-c6=""
          alt="profile-picture"
          class="profile-picture"
          src="assets/icons/user.svg"
        />
        <h4 class="name">{{ auth.loggedUser?.name | titlecase }}</h4>
      </div>
      <div *ngIf="auth.loggedUser.flags.clubMember" class="club-member-info">
        <img src="assets/icons/club-user-card.svg" alt="club-user-card" />
        <p class="club-member-name">{{ auth.loggedUser?.name | titlecase }}</p>
      </div>
    </div>
    <div class="col">
      <div class="info" *ngIf="auth.loggedUser.data?.sex">
        <h4>CUIL</h4>
        <p>{{ auth.loggedUser?.cuit | cuit }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.birthDate">
        <h4>Fecha de nacimiento</h4>
        <p>{{ auth.loggedUser.data?.birthDate | date : 'mediumDate' }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.sex">
        <h4>Sexo</h4>
        <p>{{ auth.loggedUser.data?.sex }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.civilState">
        <h4>Estado civil</h4>
        <p>{{ auth.loggedUser.data?.civilState }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.nationality">
        <h4>Nacionalidad</h4>
        <p>{{ auth.loggedUser.data?.nationality }}</p>
      </div>
      <!-- <div class="info" *ngIf="auth.loggedUser?.investorProfile">
        <h4>Perfil del Inversor</h4>
        <p>{{ auth.loggedUser?.investorProfile }}</p>
      </div> -->
    </div>
    <div class="col">
      <div class="info" *ngIf="auth.loggedUser.data?.province">
        <h4>Localidad</h4>
        <p>
          {{ auth.loggedUser.data?.province }},
          {{ auth.loggedUser.data?.city }}
        </p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.street">
        <h4 [class.expired]="this.auth?.complianceChecks?.expiredAddress">Domicilio</h4>
        <div class="value">
          <p>
            {{ auth.loggedUser.data?.street }}
            {{ auth.loggedUser.data?.numeration }}
            {{ auth.loggedUser.data?.department }}
          </p>
          <img
            *ngIf="this.auth?.complianceChecks?.expiredAddress"
            src="assets/icons/edit.svg"
            alt="edit information"
            (click)="editInfo()"
          />
        </div>
      </div>
      <div class="info">
        <h4>Email</h4>
        <p>{{ auth.loggedUser?.email }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser?.phoneNumber">
        <div class="field">
          <h4 [class.expired]="this.auth?.complianceChecks?.expiredPhone">Teléfono</h4>
          <button
            *ngIf="!this.auth?.complianceChecks?.expiredPhone"
            (click)="openChangeNumberComponent()"
          >
            Editar
          </button>
        </div>
        <div class="value">
          <p>+{{ auth.loggedUser?.phoneNumber }}</p>
          <img
            *ngIf="this.auth?.complianceChecks?.expiredPhone"
            src="assets/icons/edit.svg"
            alt="edit information"
            (click)="editInfo()"
          />
        </div>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.isUIF || auth.loggedUser.data?.isUIF == false">
        <h4>¿Está asociado a la UIF?</h4>
        <p>{{ auth.loggedUser.data?.isUIF ? 'Sí' : 'No' }}</p>
      </div>
      <!-- <div class="info" *ngIf="auth.loggedUser.data?.occupation">
        <h4>Ocupación</h4>
        <p>{{ auth.loggedUser.data?.occupation }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.IVA">
        <h4>Condición de IVA</h4>
        <p>{{ auth.loggedUser.data?.IVA }}</p>
      </div>
      <div class="info" *ngIf="auth.loggedUser.data?.ganancias">
        <h4>Condición de Ganancias</h4>
        <p>{{ auth.loggedUser.data?.ganancias }}</p>
      </div> -->
    </div>
  </div>
</div>
